const FiftyFifty = {
    classNames: {
        title: 'fifty-fifty__content-block--titleText',
        content: 'fifty-fifty__content-block--textCopy',
        button: 'fifty-fifty__content-block--buttonCta',
        image: 'fifty-fifty__imageAsset',
        disclaimer: 'fifty-fifty__content-block--disclaimerCopy'
    }
};

export default FiftyFifty;
